"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTradeConfigCenter = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const interface_1 = require("../../../../interface");
const FutureAPI_1 = require("../../../../apis/FutureAPI");
const trade_utils_lib_1 = require("trade_utils_lib");
// 获取云端用户偏好配置，使用前需要先某个页面调用loop函数开启轮询
var RemoteTradeConfigCenter;
(function (RemoteTradeConfigCenter) {
    // 默认值
    const defaultConfig = {
        [interface_1.EPreferenceKey.profit_mode]: interface_1.EPreferenceProfitMode.net,
    };
    const subject = new rxjs_1.BehaviorSubject(defaultConfig);
    let loopSubscription = null;
    // 内部订阅的observable
    const observable = subject.pipe((0, rxjs_1.map)((val) => (Object.assign(Object.assign({}, defaultConfig), val))));
    /**
     * 轮询云端配置
     */
    function loop() {
        loopSubscription === null || loopSubscription === void 0 ? void 0 : loopSubscription.unsubscribe();
        loopSubscription = (0, rxjs_1.timer)(0, 1000 * 60 * 30)
            .pipe((0, rxjs_1.mergeMap)(() => {
            return (0, trade_utils_lib_1.requestWithRetry)(() => (0, FutureAPI_1.queryUserPreferenceConfig)(), { maxRetryCount: 2 }).pipe((0, rxjs_1.catchError)(() => {
                return (0, rxjs_1.of)(defaultConfig);
            }));
        }))
            .subscribe({
            next: (res) => {
                subject.next(res);
            },
            error: () => { },
        });
    }
    RemoteTradeConfigCenter.loop = loop;
    /**
     * 取消轮询
     */
    function unLoop() {
        loopSubscription === null || loopSubscription === void 0 ? void 0 : loopSubscription.unsubscribe();
    }
    RemoteTradeConfigCenter.unLoop = unLoop;
    function update(key, value) {
        let data = {};
        if (typeof key === "string" && value !== undefined) {
            data[key] = value;
        }
        else {
            data = Object.assign({}, key);
        }
        const prevData = (0, lodash_1.cloneDeep)(subject.value);
        // 更新配置
        subject.next(data);
        return (0, FutureAPI_1.setUserPreferenceConfig)(data).pipe((0, rxjs_1.catchError)((err) => {
            // 如果接口调用失败，还原回之前的值
            subject.next(prevData);
            throw err;
        }));
    }
    RemoteTradeConfigCenter.update = update;
    /**
     * 查询云端用户偏好配置
     * @param init 是否需要初始化轮询
     */
    function useRemoteTradeConfig() {
        const [data, setData] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            const subscription = observable.subscribe({
                next: (res) => {
                    setData(res);
                },
                error: () => { },
            });
            return () => {
                subscription.unsubscribe();
            };
        }, []);
        return {
            data,
            update,
        };
    }
    RemoteTradeConfigCenter.useRemoteTradeConfig = useRemoteTradeConfig;
})(RemoteTradeConfigCenter = exports.RemoteTradeConfigCenter || (exports.RemoteTradeConfigCenter = {}));
